/** Dados mock usados apenas durante o tour da Busca de Rede (passos 4–7). */

export const BUSCA_REDE_TOUR_MOCK_FLAG = "busca_rede_tour_mock";

export function isBuscaRedeTourMockMode(): boolean {
  try {
    return sessionStorage.getItem(BUSCA_REDE_TOUR_MOCK_FLAG) === "1";
  } catch {
    return false;
  }
}

export function setBuscaRedeTourMockMode(enabled: boolean) {
  try {
    if (enabled) {
      sessionStorage.setItem(BUSCA_REDE_TOUR_MOCK_FLAG, "1");
    } else {
      sessionStorage.removeItem(BUSCA_REDE_TOUR_MOCK_FLAG);
    }
  } catch {
    // ignore
  }
}

const mockProviders = [
  {
    CodigoPrestador: "TOUR-001",
    DescricaoPrestador: "Dr. Ana Fernandes",
    DescricaoEspecialidade: "Psicologia",
    TipoLogradouro: "Rua",
    EnderecoRua: "Haddock Lobo",
    EnderecoNumero: "595",
    EnderecoComplemento: "",
    EnderecoBairro: "Cerqueira César",
    CodigoEstado: "SP",
    EnderecoCidade: "São Paulo",
    Distancia: 1.2,
    NetworkName: "Omint",
    Favorito: false,
    SrEndereco: 1,
    DsIdioma: "Português",
    ScoreTotal: 4.9,
    WhatsApp: true,
    Teleconsulta: true,
    Agendamento: true
  },
  {
    CodigoPrestador: "TOUR-002",
    DescricaoPrestador: "Dr. Ricardo Guimarães",
    DescricaoEspecialidade: "Psicologia",
    TipoLogradouro: "Av.",
    EnderecoRua: "Paulista",
    EnderecoNumero: "1000",
    EnderecoComplemento: "Conj. 101",
    EnderecoBairro: "Bela Vista",
    CodigoEstado: "SP",
    EnderecoCidade: "São Paulo",
    Distancia: 2.4,
    NetworkName: "Omint",
    Favorito: false,
    SrEndereco: 2,
    DsIdioma: "Português",
    ScoreTotal: 4.8,
    WhatsApp: false,
    Teleconsulta: true,
    Agendamento: false
  }
];

export function seedBuscaRedeTourMock(store: { commit: (type: string, payload?: unknown) => void }) {
  setBuscaRedeTourMockMode(true);

  store.commit("affiliate/SET_GROUP", "Médicos e clínicas");
  store.commit("affiliate/SET_TIPO_ATENDIMENTO", "medicos-clinicas");
  store.commit("affiliate/SET_REDE", "TOUR");
  store.commit("affiliate/SET_SPECIALITY", { cod: "TOUR-PSI", label: "Psicologia" });
  store.commit("affiliate/SET_LOCATION_TYPE", "");
  store.commit("affiliate/SET_HOME_LOCATION", {
    Titulo: "São Paulo - SP",
    Tipo: "Atual",
    Descricao: "Buscando pela sua localização atual"
  });
  store.commit("affiliate/SET_ENDERECO_SELECIONADO", {
    Titulo: "São Paulo - SP",
    Tipo: "atual",
    Descricao: "Buscando pela sua localização atual"
  });
  store.commit("affiliate/SET_SUB_SPECIALITIES", [
    { Codigo: "TOUR-SUB-1", Titulo: "Psicologia - Online" },
    { Codigo: "TOUR-SUB-2", Titulo: "Psicologia Geral" },
    { Codigo: "TOUR-SUB-3", Titulo: "Psicologia Infantil" }
  ]);
  store.commit("affiliate/SET_MATCHES", mockProviders);
  store.commit("affiliate/SET_RESULTADOS_BUSCA", {
    Data: {
      Prestadores: mockProviders,
      Total: mockProviders.length,
      Pagina: 1,
      Ordenacao: "distancia",
      OrdenacoesDisponiveis: [{ Codigo: "distancia", Titulo: "Distância", Selecionado: true }],
      FiltrosDisponiveis: [],
      FiltrosAplicados: {}
    }
  });
  store.commit("affiliate/SET_PAGINACAO", { pagina: 1, tamanhoPagina: 20 });
  store.commit("affiliate/SET_FILTERS", {
    minimumRate: "",
    facilities: [],
    languages: [],
    subspecialties: [],
    networks: []
  });
}

export function clearBuscaRedeTourMock(store?: { commit: (type: string, payload?: unknown) => void }) {
  setBuscaRedeTourMockMode(false);
  if (!store) return;

  // Limpa só o essencial para não vazar estado do tour na navegação real
  store.commit("affiliate/SET_SUB_SPECIALITIES", []);
  store.commit("affiliate/SET_MATCHES", []);
  store.commit("affiliate/SET_RESULTADOS_BUSCA", null);
}
